import React from 'react';
import type { EditorIconProps } from './EditorIconProps';

export const LlamaUndo = ({
  color = 'currentColor',
  size = 40,
  ...props
}: EditorIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      {...props}
    >
      <g transform="translate(8, 10) scale(1.0)">
        <path
          d="M2.14994 7.00006C1.51485 7.00006 1 7.51973 1 8.16078C1 8.80182 1.51485 9.32149 2.14994 9.32149H17.3292C18.9419 9.3215 20.0161 9.87927 20.6874 10.6155C21.3744 11.3691 21.7225 12.4012 21.6994 13.4747C21.6534 15.6119 20.1753 17.6786 17.3292 17.6786H10.8895C10.2544 17.6786 9.73956 18.1983 9.73956 18.8393C9.73956 19.4804 10.2544 20.0001 10.8895 20.0001H17.3292C21.6127 20 23.9293 16.7275 23.9984 13.5255C24.0328 11.9293 23.5184 10.2917 22.3799 9.0431C21.2257 7.77714 19.5113 7.00007 17.3292 7.00006H2.14994Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.61719 2.3202C9.1276 1.78942 9.1276 0.92886 8.61719 0.398083C8.10678 -0.132694 7.27924 -0.132694 6.76884 0.398083L0.382807 7.03894C-0.127603 7.56972 -0.127603 8.43028 0.382807 8.96106L6.76884 15.6019C7.27924 16.1327 8.10678 16.1327 8.61719 15.6019C9.1276 15.0711 9.1276 14.2106 8.61719 13.6798L3.15534 8L8.61719 2.3202Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

LlamaUndo.displayName = 'LlamaUndo';
